import { NgModule } from '@angular/core';
import { ClickOutDirective } from './clickout.directive';



export class ClickOutModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [ClickOutDirective],
    exports: [ClickOutDirective]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
